import styled from 'styled-components';
import BackgroundImage from 'assets/images/auth/img-product-management.jpeg';

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
       
    color: #000;
`;

export const Header = styled.div`
    width: 100%;
    background: #ccc; //#f5f5f5;
    padding: 35px 0px 7px 0px;
    display: flex;
    justify-content: center;
    align-items: center;

    background-image: url(${BackgroundImage});
    background-repeat: no-repeat, no-repeat;
    background-size: cover, cover;
    background-position: 0px -170px;
`;

export const FilterBox = styled.div`
    width: 100%;
    max-width: 1160px;

    > h1 {
        color: ${({ theme }) => theme.font.color.primary};
        font-size: 24px;
        font-family: ${({ theme }) => theme.font.fontFamily.bold};
        margin-bottom: 30px;
    }
`;

export const AllFilters = styled.div`
    width: 100%;

    background-color: #efefef;
    border-radius: 5px;
    padding: 20px;
    margin: 10px 0 5px 0;

    display: flex;
    flex-wrap: wrap;

`;

export const BoxFilters = styled.div`
    width: 100%;
    max-width: 265px;
    background-color: #efefef;
    border-radius: 5px;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-right: 15px;

    > strong {
        width: 100%;
        font-size: 16px;
        color: ${({ theme }) => theme.font.color.primary};
        font-family: ${({ theme }) => theme.font.fontFamily.bold};
        margin-bottom: 10px;
    }
`;

export const Body = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
`;

export const Result = styled.div`
    width: 100%;
    max-width: 980px;
    background: #fff;
    padding: 20px;

    > h1 {
        color: ${({ theme }) => theme.font.color.primary};
        font-size: 24px;
        font-family: ${({ theme }) => theme.font.fontFamily.bold};
        margin: 30px 0px;
    }
`;